import { Route } from '@angular/router';
import { canActivate } from './shared';

export const appRoutes: Array<Route> = [
  {
    path: 'auth',
    loadChildren: async () => import('./auth').then((m: { authRoutes: Array<Route> }) => m.authRoutes)
  },
  {
    path: 'process/create/:id',
    loadComponent: async () =>
      import('./public/views/sme-loan-application/sme-loan-application.component')
        .then(m => m.SmeLoanApplicationComponent)
  },
  {
    path: 'process/documents/:processId',
    loadComponent: async () =>
      import('./public/views/public-document-upload/public-document-upload.component')
        .then(m => m.PublicDocumentUploadComponent)
  },
  {
    path: 'apply',
    loadChildren: async () => import('./public/public.routes').then(m => m.publicRoutes)
  },
  {
    path: '',
    canActivate: [canActivate],
    loadChildren: async () => import('./dashboard').then((m: { dashboardRoutes: Array<Route> }) => m.dashboardRoutes)
  }
];
